module.exports = __webpack_public_path__ + "img/dingdan.e39c10fa.svg";